import styled from "styled-components";

const Text = styled.h1`
  color: black;
  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 20px;
    font-weight: 700;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-size: 26px;
    font-weight: 700;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-size: 32px;
    font-weight: 700;
  }
`;

type H1TextProps = {
  children: React.ReactNode;
};

export default function H1Text({ children }: H1TextProps) {
  return <Text>{children}</Text>;
}
